(function () {
  const overlay = document.getElementById("search-overlay");
  const openBtn = document.getElementById("algolia-search-button");
  const closeBtn = overlay?.querySelector(".search-overlay__close");
  const input = document.getElementById("search-box");

  if (!overlay) return;
  let lastFocusedElement = null;
  function openOverlay() {
    lastFocusedElement = document.activeElement;
    overlay.setAttribute("aria-hidden", "false");
    openBtn?.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";

    if (input) {
      setTimeout(() => {
        input.focus();
        autoResizeSearch();
      }, 10);
    }
  }

  function autoResizeSearch() {
    if (!input || input.tagName !== "TEXTAREA") return;
    input.style.height = "auto";
    input.style.height = input.scrollHeight + "px";
  }
  if (input) {
    input.addEventListener("input", autoResizeSearch);
    input.addEventListener("focus", autoResizeSearch);
  }

  function closeOverlay() {
    overlay.setAttribute("aria-hidden", "true");
    openBtn?.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    lastFocusedElement?.focus();
  }

  openBtn?.addEventListener("click", openOverlay);
  closeBtn?.addEventListener("click", closeOverlay);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.getAttribute("aria-hidden") === "false") {
      closeOverlay();
    }
  });
})();

(function () {
  var ALGOLIA_INSIGHTS_SRC =
    "https://cdn.jsdelivr.net/npm/search-insights@2/dist/search-insights.min.js";
  !(function (e, a, t, n, s, i, c) {
    (e.AlgoliaAnalyticsObject = s),
      (e[s] =
        e[s] ||
        function () {
          (e[s].queue = e[s].queue || []).push(arguments);
        }),
      (e[s].version = (n.match(/@([^\/]+)\/?/) || [])[1]),
      (i = a.createElement(t)),
      (c = a.getElementsByTagName(t)[0]),
      (i.async = 1),
      (i.src = n),
      c.parentNode.insertBefore(i, c);
  })(window, document, "script", ALGOLIA_INSIGHTS_SRC, "aa");

  var algoliaScript = document.createElement("script");
  algoliaScript.src =
    "https://cdn.jsdelivr.net/npm/algoliasearch@4/dist/algoliasearch-lite.umd.js";
  algoliaScript.async = true;
  algoliaScript.onload = initAlgoliaSearch;
  document.head.appendChild(algoliaScript);

  function initAlgoliaSearch() {
    const searchGoIconUrl =
      document.getElementById("search-overlay")?.dataset?.searchGoIcon || "";

    const ALGOLIA_APP_ID = "7MUMU8S40P";
    const ALGOLIA_API_KEY = "4714c5c3d76798b84cdd017edf83d007";
    const PAGES_INDEX = "shopify_pages";
    const ARTICLES_INDEX = "shopify_articles";
    const PRODUCTS_INDEX = "shopify_products";
    const SUGGESTIONS_INDEX = "www_slicedbread_agency_7mumu8s40p_suggestions";
    const DEBOUNCE_MS = 250;
    const POPULAR_SEARCHES = ["PPC", "Paid Advertising", "Social Ads", "Meta Ads", "SEO"];

    const searchClient = window.algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY);
    const pagesIndex = searchClient.initIndex(PAGES_INDEX);
    const articlesIndex = searchClient.initIndex(ARTICLES_INDEX);
    const productsIndex = searchClient.initIndex(PRODUCTS_INDEX);
    const suggestionsIndex = searchClient.initIndex(SUGGESTIONS_INDEX);

    const input = document.querySelector("#search-box");
    const autocompleteContainer = document.querySelector("#autocomplete");
    const autosuggestText = document.getElementById("search-autosuggest");
    const autosuggestMeasure = document.getElementById("search-autosuggest-measure");

    let currentAutosuggest = null;

    function updateAutosuggest(query) {
      if (!autosuggestText || !autosuggestMeasure) return;
      if (!query || !currentAutosuggest) {
        autosuggestText.textContent = "";
        return;
      }
      const suggestion = currentAutosuggest.toLowerCase();
      const q = query.toLowerCase();
      if (!suggestion.startsWith(q) || suggestion === q) {
        autosuggestText.textContent = "";
        return;
      }
      const completion = currentAutosuggest.slice(query.length);
      autosuggestMeasure.textContent = query;
      autosuggestText.textContent = completion;
      autosuggestText.style.marginLeft = autosuggestMeasure.offsetWidth + "px";
    }

    function setAutosuggestFromHits(query, hits) {
      const q = query.trim().toLowerCase();
      if (!q) {
        currentAutosuggest = null;
        return;
      }
      const candidates = [];
      for (const hit of hits || []) {
        const title = (hit.query || hit.suggestion || hit.title || "")
          .replace(" | Slicedbread Agency", "")
          .trim();
        if (title) candidates.push(title);
        if (hit.relatedKeywords) {
          const keywords = Array.isArray(hit.relatedKeywords)
            ? hit.relatedKeywords
            : String(hit.relatedKeywords).split(",");
          for (const kw of keywords) {
            const k = kw.trim();
            if (k) candidates.push(k);
          }
        }
      }
      const match = candidates.find((c) => c.toLowerCase().startsWith(q) && c.toLowerCase() !== q);
      currentAutosuggest = match || null;
    }

    function clearAutosuggest() {
      currentAutosuggest = null;
      if (autosuggestText) autosuggestText.textContent = "";
    }

    if (typeof aa === "function") {
      aa("init", { appId: ALGOLIA_APP_ID, apiKey: ALGOLIA_API_KEY });
    }

    let suggestionIndex = -1;
    let debounceTimer;
    let lastSuggestionsQueryID = null;
    let lastPagesQueryID = null;
    let lastProductsQueryID = null;
    let lastArticlesQueryID = null;

    const loadingHtml =
      '<div class="search-loading" aria-live="polite" aria-label="Searching"><span class="search-loading__dot"></span><span class="search-loading__dot"></span><span class="search-loading__dot"></span></div>';
    const submittedSelector = ".search-results-articles, .search-results-pages, .search-results-empty";

    input.addEventListener("input", () => {
      const query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length === 0) {
        autocompleteContainer.innerHTML = "";
        input.setAttribute("aria-expanded", "false");
        suggestionIndex = -1;
        clearAutosuggest();
        return;
      }

      updateAutosuggest(query);

      if (
        !autocompleteContainer.querySelector(".search-results-articles, .search-results-pages") &&
        !autocompleteContainer.querySelector(".search-loading")
      ) {
        autocompleteContainer.innerHTML = loadingHtml;
      }

      if (query.length < 3) return;

      debounceTimer = setTimeout(async () => {
        const hasSubmitted = !!autocompleteContainer.querySelector(submittedSelector);

        try {
          const { hits, queryID } = await suggestionsIndex.search(query, {
            hitsPerPage: 6,
            clickAnalytics: true,
          });
          lastSuggestionsQueryID = queryID || null;
          setAutosuggestFromHits(query, hits);
          updateAutosuggest(input.value.trim());

          if (hasSubmitted) return;

          const html = hits
            .map((hit, i) => {
              const title = (hit.query || hit.suggestion || hit.title || "").replace(
                " | Slicedbread Agency",
                ""
              );
              const url = hit.url || "#";
              const isQuerySuggestion = !hit.url;
              return `
          <div class="search-autocomplete__result">
            <img src="${searchGoIconUrl}" class="icon"/>
            <a
              href="${url}"
              class="search-page-result"
              role="option"
              data-index="${i}"
              data-suggestion="${title.replace(/"/g, "&quot;")}"
              data-is-query="${isQuerySuggestion}"
              data-object-id="${(hit.objectID || "").replace(/"/g, "&quot;")}"
              data-position="${i + 1}"
              data-index-name="${SUGGESTIONS_INDEX}"
              data-query-id="${queryID || ""}"
            >
              ${title}
            </a>
          </div>
        `;
            })
            .join("");

          autocompleteContainer.innerHTML = html;
          input.setAttribute("aria-expanded", "true");
          suggestionIndex = -1;
          updateAutosuggest(input.value.trim());

          if (typeof aa === "function" && hits.length) {
            const objectIDs = hits.map((h) => h.objectID).filter(Boolean);
            if (objectIDs.length) {
              aa("viewedObjectIDs", {
                index: SUGGESTIONS_INDEX,
                eventName: "Suggestions Viewed",
                objectIDs,
              });
            }
          }
        } catch (err) {
          console.error("Autocomplete error:", err);
          autocompleteContainer.innerHTML = "";
        }
      }, DEBOUNCE_MS);
    });

    autocompleteContainer.addEventListener("click", async (e) => {
      const link = e.target.closest("a[data-query-id], a[data-is-query]");
      if (!link) return;

      const queryId = link.getAttribute("data-query-id");
      const objectId = link.getAttribute("data-object-id");
      const position = parseInt(link.getAttribute("data-position"), 10);
      const indexName = link.getAttribute("data-index-name");
      const eventName = link.classList.contains("search-article-link")
        ? "Article Clicked"
        : link.classList.contains("search-submitted__result")
          ? "Page Clicked"
          : "Suggestion Clicked";

      if (typeof aa === "function" && queryId && objectId && indexName) {
        aa("clickedObjectIDsAfterSearch", {
          eventName,
          index: indexName,
          queryID: queryId,
          objectIDs: [objectId],
          positions: [position],
        });
      }

      if (link.getAttribute("data-is-query") === "true") {
        e.preventDefault();
        const suggestion = link.getAttribute("data-suggestion") || "";
        input.value = suggestion;
        input.dispatchEvent(new Event("input"));
        runPagesArticlesSearch(suggestion);
        return;
      }

      const href = link.getAttribute("href");
      if (href && href !== "#") {
        e.preventDefault();
        setTimeout(() => {
          window.location.href = href;
        }, 150);
      }
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") e.preventDefault();

      if ((e.key === "Tab" || e.key === "ArrowRight") && currentAutosuggest) {
        const query = input.value.trim();
        if (query && currentAutosuggest.toLowerCase().startsWith(query.toLowerCase())) {
          e.preventDefault();
          input.value = currentAutosuggest;
          clearAutosuggest();
          input.dispatchEvent(new Event("input"));
          return;
        }
      }

      const resultLinks = autocompleteContainer.querySelectorAll(".search-page-result");

      if (e.key === "ArrowDown" && resultLinks.length) {
        e.preventDefault();
        suggestionIndex = (suggestionIndex + 1) % resultLinks.length;
        updateHighlight(resultLinks);
        return;
      }

      if (e.key === "ArrowUp" && resultLinks.length) {
        e.preventDefault();
        suggestionIndex = (suggestionIndex - 1 + resultLinks.length) % resultLinks.length;
        updateHighlight(resultLinks);
        return;
      }

      if (e.key === "Enter") {
        if (suggestionIndex >= 0 && resultLinks.length) {
          const selected = resultLinks[suggestionIndex];
          if (selected) {
            if (selected.getAttribute("data-is-query") === "true") {
              const suggestion = selected.getAttribute("data-suggestion") || "";
              input.value = suggestion;
              input.dispatchEvent(new Event("input"));
              runPagesArticlesSearch(suggestion);
            } else {
              const qid = selected.getAttribute("data-query-id");
              const oid = selected.getAttribute("data-object-id");
              const pos = parseInt(selected.getAttribute("data-position"), 10);
              const idx = selected.getAttribute("data-index-name");
              if (typeof aa === "function" && qid && oid && idx) {
                aa("clickedObjectIDsAfterSearch", {
                  eventName: "Suggestion Clicked",
                  index: idx,
                  queryID: qid,
                  objectIDs: [oid],
                  positions: [pos],
                });
              }
              window.location.href = selected.getAttribute("href");
            }
          }
          return;
        }
        const query = input.value.trim();
        if (query.length >= 3) runPagesArticlesSearch(query);
        return;
      }

      if (e.key === "Escape") {
        autocompleteContainer.innerHTML = "";
        input.setAttribute("aria-expanded", "false");
        suggestionIndex = -1;
        clearAutosuggest();
      }
    });

    function updateHighlight(list) {
      list.forEach((item, idx) => {
        item.classList.toggle("highlighted-suggestion", idx === suggestionIndex);
      });
    }

    async function runPagesArticlesSearch(query) {
      try {
        const [pagesRes, productsRes, articlesRes] = await Promise.all([
          pagesIndex.search(query, { hitsPerPage: 9, clickAnalytics: true }),
          productsIndex.search(query, { hitsPerPage: 9, clickAnalytics: true }),
          articlesIndex.search(query, { hitsPerPage: 10, clickAnalytics: true }),
        ]);
        lastPagesQueryID = pagesRes.queryID || null;
        lastProductsQueryID = productsRes.queryID || null;
        lastArticlesQueryID = articlesRes.queryID || null;
        renderResults(pagesRes.hits, productsRes.hits, articlesRes.hits);
      } catch (err) {
        console.error("Search error:", err);
      }
    }

    function isCareersBlogArticle(hit) {
      return (hit.blog?.title || "").trim().toLowerCase() === "careers";
    }

    function renderResults(pages, products, articles) {
      suggestionIndex = -1;
      clearAutosuggest();
      const query = input.value.trim();

      const noResults =
        (!pages || pages.length === 0) &&
        (!products || products.length === 0) &&
        (!articles || articles.length === 0);
      if (noResults) {
        const popularHtml = POPULAR_SEARCHES.map(
          (term) => `
        <div class="search-autocomplete__result">
          <img src="${searchGoIconUrl}" class="icon"/>
          <a href="#" class="search-page-result" data-is-query="true" data-suggestion="${term.replace(/"/g, "&quot;")}" data-query-id="" data-object-id="" data-index-name="" role="option">${term}</a>
        </div>
      `
        ).join("");

        autocompleteContainer.innerHTML = `
        <div class="search-results-empty">
          <p class="search-results-empty__message">No results found for <strong>${query.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</strong>.</p>
          <p class="search-results-empty__message">Please try another search term or choose from our popular searches below.</p>
          <div class="search-results-popular">
            ${popularHtml}
          </div>
        </div>
      `;
        input.setAttribute("aria-expanded", "true");
        return;
      }

      const GRID_SIZE = 9;
      const gridHits = [
        ...(pages || []).map((h) => ({ ...h, _src: "page" })),
        ...(articles || []).map((h) => ({ ...h, _src: "article" })),
        ...(products || []).map((h) => ({ ...h, _src: "product" })),
      ].slice(0, GRID_SIZE);

      const pageResults = gridHits
        .map((hit, i) => {
          let href, queryId, indexName;
          if (hit._src === "page") {
            href = `/pages/${hit.handle}`;
            queryId = lastPagesQueryID || "";
            indexName = PAGES_INDEX;
          } else if (hit._src === "article") {
            href = hit.blog?.handle && hit.handle ? `/blogs/${hit.blog.handle}/${hit.handle}` : "#";
            queryId = lastArticlesQueryID || "";
            indexName = ARTICLES_INDEX;
          } else {
            href = `/products/${hit.handle}`;
            queryId = lastProductsQueryID || "";
            indexName = PRODUCTS_INDEX;
          }
          const titleText = (hit.title || "").replace(" | Slicedbread Agency", "");
          let innerHtml = titleText;
          if (hit._src === "article") {
            const blogTitle = (hit.blog?.title || "").trim();
            const isCareers = blogTitle.toLowerCase() === "careers";
            const pillClass = isCareers ? "tag-article tag-career" : "tag-article";
            const pillLabel = isCareers ? "Careers" : "Blog";
            innerHtml = `<span class="${pillClass}">${pillLabel}</span>${titleText}`;
          }
          return `
      <a href="${href}" class="search-page-result search-submitted__result"
        data-object-id="${(hit.objectID || "").replace(/"/g, "&quot;")}"
        data-position="${i + 1}"
        data-index-name="${indexName}"
        data-query-id="${queryId}">
        ${innerHtml}
      </a>
    `;
        })
        .join("");

      const articlesForList = (articles || []).filter((a) => !isCareersBlogArticle(a));

      const articleResults = articlesForList
        .map((article, i) => {
          const articleUrl =
            article.blog?.handle && article.handle
              ? `/blogs/${article.blog.handle}/${article.handle}`
              : "#";
          const articleDate = article.published_at
            ? new Date(article.published_at).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              }) + " &nbsp;-&nbsp; "
            : "";
          return `
      <article class="search-article">
        <a href="${articleUrl}" class="search-article-link"
          data-object-id="${(article.objectID || "").replace(/"/g, "&quot;")}"
          data-position="${i + 1}"
          data-index-name="${ARTICLES_INDEX}"
          data-query-id="${lastArticlesQueryID || ""}">
          <div class="search-article__inner">
            <div class="search-article__image"
              style="background-image:url('${(article.image || "").replace(/(\.[a-z]+)(\?|$)/i, "_550x$1$2")}')"></div>
            <div class="search-article__meta">
              <div class="search-article__details">
                ${articleDate}${article.blog?.title || ""}
              </div>
              <h3 class="search-article__title">${article.title || ""}</h3>
            </div>
          </div>
        </a>
      </article>
    `;
        })
        .join("");

      autocompleteContainer.innerHTML = `
      <div class="search-results-pages">${pageResults}</div>
      <div class="search-results-articles">${articleResults}</div>
    `;

      if (typeof aa === "function") {
        const pageIds = (pages || []).map((p) => p.objectID).filter(Boolean);
        if (pageIds.length)
          aa("viewedObjectIDs", { index: PAGES_INDEX, eventName: "Pages Viewed", objectIDs: pageIds });
        const productIds = (products || []).map((p) => p.objectID).filter(Boolean);
        if (productIds.length)
          aa("viewedObjectIDs", {
            index: PRODUCTS_INDEX,
            eventName: "Products Viewed",
            objectIDs: productIds,
          });
        const gridArticleIds = gridHits
          .filter((h) => h._src === "article")
          .map((h) => h.objectID)
          .filter(Boolean);
        const listArticleIds = articlesForList.map((art) => art.objectID).filter(Boolean);
        const articleIds = [...new Set([...gridArticleIds, ...listArticleIds])];
        if (articleIds.length)
          aa("viewedObjectIDs", {
            index: ARTICLES_INDEX,
            eventName: "Articles Viewed",
            objectIDs: articleIds,
          });
      }
    }
  }
})();
